import http from '@/http';
import createCrudModule from 'vuex-crud';
import { withDataFilter } from '@/store/index';

const store = createCrudModule({
  client: http,
  resource: 'dictionary/advantages',
  urlRoot: 'dictionary/advantages'
});

export default withDataFilter(store);
